import React from 'react';
import { CreateUserForm, UserForm, GatewayForm } from './Forms';
import { useUser } from '../../Context/UserContext';

import { AddressFormNbiot } from '../Forms/AddressForm';
import UsersTable from './SettingDataUsers'
import { OrganizationForm, GroupForm } from '../Forms/NbiotForm'
import AddressTable from './SettingDataAddress';

function SettingDataContent({ selectedMenu, onMenuChange }) {
    const { user } = useUser();

    const forms = [
        { id: "users", name: "Создание Пользователей", component: <UsersTable onMenuChange={onMenuChange} /> },
        { id: "address", name: "Адреса", component: <AddressTable onMenuChange={onMenuChange} /> },
        { id: "createUser", name: "Создание Пользователей", component: <CreateUserForm /> },
        { id: "createGateway", name: "Создание Шлюзов", component: <GatewayForm /> },
        { id: "organization", name: "Создание Организаций", component: <OrganizationForm /> },
        { id: "group", name: "Создание Групп", component: <GroupForm /> }
    ];

    const selectedForm = forms.find(form => form.id === selectedMenu);

    return (
        <>
            {selectedMenu !== null && selectedForm && selectedForm.component}
        </>
    )
}

export default SettingDataContent;